import { render, staticRenderFns } from "./NewPlatformForm.vue?vue&type=template&id=1d702c12&lang=pug&"
import script from "./NewPlatformForm.vue?vue&type=script&lang=js&"
export * from "./NewPlatformForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports